import { ApiService } from "../../../../services/apiService";
import { Dispatch } from "redux";
import { appConstants } from "../../../action-constants/inapp.constants";
import { routes } from "../../../../services/paths";
import { handleRequestErrors, printBase64ImageAsPDF } from "../../../../shared/utils";

export const GetOrderShipmentLabel = (actionPayload: any) => {
  if (actionPayload !== "CLEAR") {
    return (dispatch: Dispatch) => {
      let apiConsume = ApiService.request({
        url: `${routes.GET_SHIPMENT_LABEL}?shipmentId=${actionPayload}`,
        http_method: "GET",
      });
      dispatch(request(apiConsume));
      return apiConsume
        .then((response: any) => {
          printBase64ImageAsPDF(response.data as unknown as string);
          dispatch(success(response.data));
        })
        .catch((error: any) => {
          dispatch(failure(handleRequestErrors(error)));
        });
    };
  }

  return (dispatch: Dispatch) => {
    dispatch(clear());
  };

  function request(params: any) {
    return { type: appConstants.GET_SHIPMENT_LABEL_PENDING, params };
  }
  function success(response: any) {
    return { type: appConstants.GET_SHIPMENT_LABEL_SUCCESS, response };
  }
  function failure(error: any) {
    return { type: appConstants.GET_SHIPMENT_LABEL_FAILURE, error };
  }
  function clear() {
    return { type: appConstants.GET_SHIPMENT_LABEL_RESET, clear_data: "" };
  }
};
